export enum AttachmentViewPoint {
  None = 0,
  Customer = 1, // CT (AG)
  Contractor = 2, // CO (AN)
  Subcontractor = 4 // SC
}
